import { InspectionActionTypes } from '../inspection.action-types'

const initialStates = {
    inspectionForm: [],
    inspections: [],
    detailInspection: {},
    inspectionQueries: {},
}

const InspectionInfoReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case InspectionActionTypes.GET_INSPECTION_FORM:
            return {
                ...state,
                inspectionForm: action.payload,
            }
        case InspectionActionTypes.GET_INSPECTIONS:
            return {
                ...state,
                inspections: action.payload,
            }
        case InspectionActionTypes.GET_INSPECTION_DETAIL:
            return {
                ...state,
                detailInspection: action.payload,
            }
        case InspectionActionTypes.SET_INSPECTION_QUERIES:
            return {
                ...state,
                inspectionQueries: action.payload,
            }
        default:
            return { ...state }
    }
}
export default InspectionInfoReducer
